export default params => {
  let fragments = [];

  if (params.region) {
    fragments.push(params.region);
  }

  if (params.country) {
    fragments.push(params.country);
  }

  if (params.city) {
    fragments.push(params.city);
  }

  if (params.store) {
    fragments.push(params.store);
  }

  if (params.username) {
    fragments.push(params.username);
  }

  if (fragments.length > 0) {
    return '/' + fragments.join('/');
  }

  return '';
}
